import React, { useContext } from "react";
import "./ProductDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "react-query";
import Slider from "react-slick";
import { RotatingLines } from "react-loader-spinner";
import { Helmet } from "react-helmet";
import { cartContext } from "../../context/Car/CarContext";
import toast from 'react-hot-toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { StoreContext } from "../../context/StoreContext/StoreContext";


export default function ProductDetails() {
    // let {counter, setcounter}=useContext(StoreContext)
  
  let params = useParams();
  let navigate=useNavigate();
  let  {addToCart}  = useContext(cartContext);
  async function addProduct(productId) {
    let response = await addToCart(productId);
    console.log(response);
    if(localStorage.getItem("userToken")===null){
      navigate('/login')
      toast.error("Error adding product,You Must login");
    }
    else if (response.data.message === "Item(s) added to cart.") {
      toast.success("product successfully Added", {
        duration: 3000,
        position: "top-center",
      });
    } 
    else{
      toast.error("Error adding product");


    }
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function getPrductDetails(id) {
    return axios.get(
      `https://vehex-production.up.railway.app/product/getCarById/${id}`
    );

  }

  let { isLoading, isError, data } = useQuery("productdetails", () =>
    getPrductDetails(params.id)
 
  );
  console.log(data);
  return (
    <>
      {isLoading ? (
        <div className="position-fixed top-50 start-50 translate-middle">
          <RotatingLines
            strokeColor="green"
            strokeWidth="5"
            animationDuration="1"
            width="85"
            visible={true}
          />
        </div>
      ) : (
        <>
          {data?.data.product ? (
            <>
              <div className="container py-3">
              <div className="row productDetail  py-2 w-75 m-auto align-items-center">
                <Helmet>
                  <meta
                    name="description"
                    content={data?.data.product.description}
                  />
                  <title>{data?.data.product.name}</title>
                </Helmet>
                <div className="col-md-3 my-3">
                      <Slider {...settings}>
                        {data?.data.product.image.map((img, index) => {
                          return (
                            <div key={index}>
                              <img
                                src={img.secure_url}
                                className="slider-image"
                                alt={data?.data.product.name}
                              />
                            </div>
                          );
                        })}
                      </Slider>
                  </div>

                <div className="col-md-9">
                  <h4 className=" main-color">{data?.data.product.name}</h4>
                  <p className="fs-6">{data?.data.product.description}</p>
                  <h6 className="main-color">
                    Price : <span className="text-black">{data?.data.product.price} SAR</span>
                  </h6>
                  <button
                    onClick={() => {addProduct(data?.data.product._id);
                    }}
                    className=" bg-main-color text-white w-100 mt-2 rounded-2"
                  >
                    Add to Cart <i class="fa-solid fa-cart-shopping"></i> 
                  </button>
                </div>
              </div>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}
